<template>
    <div class="city">
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>加盟商管理</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>加盟商列表</h2>
                <div class="item" @click="add"><i class="icon el-icon-circle-plus" type="primary"></i>新建加盟商</div>
            </div>
        </div>
        <div class="page-content">
            <div class="table">
                <el-form :inline="true" class="demo-form-inline"  size="mini">
                    <el-form-item label="城市名称" v-if="role_id==1">
                        <el-select v-model="city_name" filterable placeholder="输入城市关键字" clearable @clear="searchList()">
                            <el-option
                                    v-for="item in cityList"
                                    :key="item.name"
                                    :label="item.name"
                                    :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="加盟商手机号">
                        <el-input v-model="mobile" maxlength="11" placeholder="请输入加盟商手机号" clearable @clear="searchList()"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="searchList">查询</el-button>
                    </el-form-item>
                </el-form>

                <el-table
                        :data="allianceList"
                        border
                        size="mini"
                        style="width: 100%">
                    <el-table-column
                            prop="name"
                            label="所属城市名称"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="realname"
                            label="加盟商姓名"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="username"
                            label="加盟商账号"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="mobile"
                            label="加盟商电话"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="role_name"
                            label="加盟商类型"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="login_total"
                            label="登录总次数"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="last_login"
                            label="最后登录时间"
                            width="150"
                            align="center"
                    >
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="updateRow(scope.row)">信息修改</el-button>
                            <el-button type="text" size="small" @click="deleteRow(scope.row)">删除</el-button>
                            <el-button type="text" size="small" v-if="scope.row.role_id==4" @click="updateLimits(scope.row)">权限修改</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="pages"
                        :current-page="page"
 :page-size="20"
                        @current-change="handleCurrentChange"
                        style="margin-top: 20px; text-align: right;"
                >
                </el-pagination>
            </div>
            <el-dialog
                    title="加盟商信息修改"
                    :visible.sync="dialogVisible"
                    width="600px"
                    >
                <el-form ref="form" :model="form" label-width="100px" align="left" style="width: 350px;">
                    <el-form-item label="用户名">
                        <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="密码">
                        <el-input v-model="form.password" placeholder="请输入密码"></el-input>
                    </el-form-item>
                    <el-form-item label="真实姓名">
                        <el-input v-model="form.realname" placeholder="请输入加盟商真实姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码">
                        <el-input v-model="form.mobile" placeholder="请输入加盟商手机号码"></el-input>
                    </el-form-item>
                    <el-form-item label="用户角色">
                        <el-select v-model="form.role_id" filterable placeholder="请选择角色">
                            <el-option
                                    v-for="item in roleList"
                                    :key="item.role_id"
                                    :label="item.role_name"
                                    :value="item.role_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="form.role_id==3">
                        <el-checkbox-group v-model="form.checkList">
                            <el-checkbox :label="item.cate_id" v-for="item in roleType"  :key="item.cate_id" >{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="所属城市">
                        <el-select v-model="form.city_id" filterable placeholder="输入城市关键字">
                            <el-option
                                    v-for="item in cityList"
                                    :key="item.city_id"
                                    :label="item.name"
                                    :value="item.city_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submitUpdate">确 定</el-button>
                 </span>
            </el-dialog>
            <el-dialog
                title="管理员权限修改"
                :visible.sync="limitPop"
                width="600px">
                    <el-tree
                            ref="upTree"
                            :data="Qxlist"
                            show-checkbox
                            node-key="id"
                            :default-checked-keys="limitData"
                            :props="defaultProps">
                    </el-tree>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelLimit">取 消</el-button>
                    <el-button type="primary" @click="submitLimit">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {getCityList,searchCity} from "../../api/city";
    import {getRoleList,roleList} from '../../api/role'
    import {delBusiness,spaceType,editBusiness} from '../../api/agency'
    export default {
        name: "alliance",
        data() {
            return {
                page: 1,
                pages: 1,
                city_name: '',
                mobile:'',
                username:'',
                realname: '',
                formInline: {
                    user: '',
                    region: ''
                },
                dialogVisible: false,
                handleType:1,//1-添加，2-修改
                form: {
                    username: '',
                    password: '',
                    realname: '',
                    mobile: '',
                    role_id: '',
                    city:'',
                    city_id:'',
                    checkList:[],
                    proxy_type_ids:'',
                },
                roleList:[],
                cityList:[],
                allianceList:[],
                roleType:[],
                limitPop:false,
                Qxlist:[],//权限列表
                limitData:[],//已有权限
                defaultProps: {
                    children: 'child',
                    label: 'cname'
                },
                role_id:0,
                curData:[],
            }
        },
        mounted() {
            this.role_id=localStorage.getItem('ROLE');
            this.getAllianceList();
            this.getRoleList();
            this.searchCity();
            this.spaceType();
            this.getQxlist();
        },
        methods: {
            //获取权限列表
            getQxlist(){
                roleList().then(res=>{
                    if(res.code==1){
                        this.Qxlist=res.data;
                    }
                })
            },
            getAllianceList() {
                getCityList({
                    city_name: this.city_name,
                    realname: this.realname,
                    mobile: this.mobile,
                    p: this.page
                }).then(res => {
                    if (res.code == 1) {
                        let list = res.data.list;

                        this.allianceList= list.map(val=>{
                            val.checkList=val.proxy_type_ids.split(',');
                            return val;
                        });
                        this.pages = res.data.total_num;
                    }
                })
            },
            searchList(){
                this.page=1;
                this.getAllianceList();
            },
            spaceType(){
                spaceType().then(res=>{
                    if(res.code==1){
                        this.roleType=res.data;
                    }
                })
            },
            updateRow(row){
                this.form=row;
                console.log(row);
                if(this.form.proxy_type_ids.length>0){
                    let arr=this.form.proxy_type_ids.split(',');
                    arr=arr.map(val=>{
                        return parseInt(val);
                    });
                    this.form.checkList=arr;
                }else{
                    this.form.checkList=[];
                }
                this.dialogVisible=true;
            },

            submitUpdate(){
                editBusiness({
                    username:'',
                    password:'',
                    realname:this.form.realname,
                    mobile:this.form.mobile,
                    id:this.form.id,
                    role_id:this.form.role_id,
                    city_id:this.form.city_id,
                    proxy_type_ids:this.form.checkList.join(',')
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('修改成功');
                        this.dialogVisible=false;
                        this.getAllianceList();
                        this.form={
                            username: '',
                            password: '',
                            realname: '',
                            mobile: '',
                            role_id: '',
                            city:'',
                            city_id:'',
                            checkList:[],
                            proxy_type_ids:'',
                        }
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            onSubmit() {
                this.getAllianceList();
            },
            deleteRow(row) {
                this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delBusiness({id:row.id,admin_id:row.admin_id}).then(res=>{
                        if(res.code==1){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getAllianceList();
                        }else{
                            this.$message({
                                type: 'warning',
                                message: res.msg
                            });
                        }
                    })
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getAllianceList()
            },
            add() {
                this.$router.push({path: '/alliance/add'});
            },
            getRoleList(){
                getRoleList().then(res=>{
                    if(res.code==1){
                        this.roleList=res.data;
                        if(this.role_id==2){
                            this.roleList.shift();
                        }else if(this.role_id==3){
                            this.roleList.splice(0,2);
                        }
                    }
                })
            },
            searchCity(){
                searchCity({level:2}).then(res=>{
                    if(res.code==1){
                        console.log(res);
                        this.cityList=res.data;
                    }
                })
            },
            //权限修改
            updateLimits(row){
                this.form=row;
                console.log(row);
                let arr=row.role_adm_access_ids.split(',');
                if(arr&&arr.length>0){
                    this.limitData=arr
                }else{
                    this.limitData=[];
                }
                console.log(this.limitData);
                this.limitPop=true;
            },
            cancelLimit(){
                this.getQxlist();
                this.limitPop=false;
                this.limitData=[];
                this.form={
                    username: '',
                    password: '',
                    realname: '',
                    mobile: '',
                    role_id: '',
                    city:'',
                    city_id:'',
                    checkList:[],
                    proxy_type_ids:'',
                }
            },
            submitLimit(){
                let arr=this.$refs.upTree.getCheckedNodes();
                console.log(arr);
                let ids=[],ads=[];
                arr.map(val=>{
                    if(val.fid!=0){
                        ids.push(val.id);
                    }else{
                        ads.push(val.id)
                    }
                })
                this.form.role_adm_access_ids=ids.join(',');
                this.form.role_adm_id=ads.join(',');
                console.log(this.form);
                editBusiness(this.form).then(res=>{
                    if(res.code==1){
                        this.$message.success('修改成功');
                        this.limitPop=false;
                        this.limitData=[];
                        this.form={
                            username: '',
                            password: '',
                            realname: '',
                            mobile: '',
                            role_id: '',
                            city:'',
                            city_id:'',
                            checkList:[],
                            proxy_type_ids:'',
                        }
                        this.getAllianceList();
                        this.getQxlist();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            }
        }

    }
</script>

<style lang="scss" scoped>
    .top-box {
        width: 100%;
        height: 100px;
        background-color: #ffffff;
        padding: 20px;

        .tab-list {
            margin-top: 20px;

            h2 {
                margin-right: 20px;
                padding-right: 20px;
                border-right: 1px solid #eaeaea;
            }

            .item {
                font-size: 16px;
                color: #409EFF;
                display: flex;
                align-items: center;
                cursor: pointer;

                .icon {
                    font-size: 20px;
                    color: #409EFF;
                    margin-right: 5px;
                }
            }
        }

    }

    .page-content {
        padding: 20px;

        .table {
            text-align: left;
            width: 100%;
            background-color: #fff;
            padding: 30px;
            box-shadow: 0 4px 4px 0 #e1e5eb;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
        }
    }
</style>
